import { PlansTab } from "../../plans/UniversalPlansBox";

const MarketApiPlansTab = () => {
  const marketApiServiceType =
    Number(import.meta.env.VITE_MARKET_API_SERVICE_TYPE) || 9;
  return (
    <>
      <PlansTab serviceType={marketApiServiceType} />
    </>
  );
};

export default MarketApiPlansTab;
